import OrderHintProductCategoryOrderHintShortTypeDescription from "@commercetools-local/topics/order-hint/product-category-order-hint-short-type-description.mdx";
import * as React from 'react';
export default {
  OrderHintProductCategoryOrderHintShortTypeDescription,
  React
};